import * as React from 'react'
import Stack from '@mui/material/Stack'
import { Field } from 'formik'
import { MuiCheckboxFormik } from '@user/components/Formik'
import { useData } from '../hooks'

export function SetAsNextActionDateCheckbox() {
  const { dueDateValid } = useData()

  return (
    <Stack spacing={0}>
      <Field
        component={MuiCheckboxFormik}
        disabled={!dueDateValid}
        inputProps={{ p: 0 }}
        label="Set as Next Action Date"
        labelProps={{ mb: 0 }}
        name="setDueDateAsNextActionDate"
        size="small"
        color="primary"
        spacing="small"
        data-test-id={`activity-form-set-as-next-action-date-checkbox`}
      />
    </Stack>
  )
}
